export const LEAD_POINT_PEOPLE_TYPES = ['ATTENDANCE', 'ACADEMIC', 'POSTSECONDARY', 'REGENTS', 'CREDITS'];
export const NON_LEAD_POINT_PEOPLE_TYPES = ['GUIDANCE_COUNSELOR', 'ADVISOR', 'SUPPORT_LEAD'];
